module.exports = __webpack_public_path__ + "img/44.479cd50c.png";